/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.4.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class IngestionMonitorApiClientService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dev.psps714.com/ingestion-monitor-service";
    }

    /**
     * @return 200 response
     */
    getExceptions(correlationId: string, exceptionType: string): Observable<ExceptionsGetResponse> {
        let url_ = this.baseUrl + "/exceptions?";
        if (correlationId === undefined || correlationId === null)
            throw new Error("The parameter 'correlationId' must be defined and cannot be null.");
        else
            url_ += "correlationId=" + encodeURIComponent("" + correlationId) + "&";
        if (exceptionType === undefined || exceptionType === null)
            throw new Error("The parameter 'exceptionType' must be defined and cannot be null.");
        else
            url_ += "exceptionType=" + encodeURIComponent("" + exceptionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceptions(<any>response_);
                } catch (e) {
                    return <Observable<ExceptionsGetResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExceptionsGetResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetExceptions(response: HttpResponseBase): Observable<ExceptionsGetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ExceptionsGetResponse>JSON.parse(_responseText, this.jsonParseReviver);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result504: any = null;
                result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExceptionsGetResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    exceptions(): Observable<void> {
        let url_ = this.baseUrl + "/exceptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExceptions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExceptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getHealth(): Observable<HealthStatusResponse> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealth(<any>response_);
                } catch (e) {
                    return <Observable<HealthStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetHealth(response: HttpResponseBase): Observable<HealthStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <HealthStatusResponse>JSON.parse(_responseText, this.jsonParseReviver);
                return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result504: any = null;
                result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthStatusResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param toDate (optional) 
     * @param searchAfter (optional) 
     * @param sortOrder (optional) 
     * @param fileType (optional) 
     * @param fromDate (optional) 
     * @param addressSearch (optional) 
     * @param size (optional) 
     * @return 200 response
     */
    getIngestionStatus(toDate: string | null | undefined, searchAfter: string | null | undefined, sortOrder: string | null | undefined, fileType: string | null | undefined, fromDate: string | null | undefined, addressSearch: string | null | undefined, size: string | null | undefined): Observable<IngestionStatusGetResponse> {
        let url_ = this.baseUrl + "/ingestion-status?";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (searchAfter !== undefined && searchAfter !== null)
            url_ += "searchAfter=" + encodeURIComponent("" + searchAfter) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (fileType !== undefined && fileType !== null)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (addressSearch !== undefined && addressSearch !== null)
            url_ += "addressSearch=" + encodeURIComponent("" + addressSearch) + "&";
        if (size !== undefined && size !== null)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetIngestionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngestionStatus(<any>response_);
                } catch (e) {
                    return <Observable<IngestionStatusGetResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<IngestionStatusGetResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetIngestionStatus(response: HttpResponseBase): Observable<IngestionStatusGetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <IngestionStatusGetResponse>JSON.parse(_responseText, this.jsonParseReviver);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result504: any = null;
                result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngestionStatusGetResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    ingestionStatus(): Observable<void> {
        let url_ = this.baseUrl + "/ingestion-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIngestionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngestionStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processIngestionStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IngestionStatusItem {
    batchesInitiated?: number | undefined;
    fileName: string;
    batchesSuccessful?: number | undefined;
    devicesListPSPS?: string | undefined;
    addressesGoogleDuplicate?: number | undefined;
    addressesSuccessful?: number | undefined;
    devicesProcessed?: number | undefined;
    processedOn: number;
    devicesUnplanned?: number | undefined;
    devicesReceived?: number | undefined;
    id: string;
    addressesExactDuplicate?: number | undefined;
    addressesMalformed?: number | undefined;
    devicesAssessing?: number | undefined;
    version: string;
    s3Bucket: string;
    devicesPSPS?: number | undefined;
    addressesNull?: number | undefined;
    addressesBlocked?: number | undefined;
    devicesListUnplanned?: string | undefined;
    devicesListAssessing?: string | undefined;
    messageLevel?: string | undefined;
    addressesFailed?: number | undefined;
    addressesTotal?: number | undefined;
    fileType: string;
}

export interface ServiceAddress {
    address: string;
    city: string;
    postalCode: string;
    state: string;
    deviceId: string;
}

export interface ExceptionsGetResponse {
    result: Exception[];
}

export interface IngestionStatusGetResponse {
    result: Result;
}

export interface ActiveAddressSortKey {
    last: string;
    first: string;
}

export interface HealthStatus {
    executionTime?: number | undefined;
    dbResponseTime?: string | undefined;
    logLevel?: string | undefined;
    environmentName?: string | undefined;
    component2ResponseTime?: string | undefined;
    dbStatus?: string | undefined;
    component2Status?: string | undefined;
    region?: string | undefined;
    version?: string | undefined;
    errors?: any[] | undefined;
    status?: string | undefined;
}

export interface ErrorDto {
    data?: any | undefined;
    errorCode?: number | undefined;
    message?: string | undefined;
}

export interface Exception {
    exceptionType: ExceptionType;
    address: ServiceAddress;
    correlationId: string;
    id: string;
}

export interface HealthStatusResponse {
    result: HealthStatus;
}

export interface Result {
    total: number;
    sortKey?: ActiveAddressSortKey | undefined;
    files: IngestionStatusItem[];
}

export enum ExceptionType {
    BLOCKED = "BLOCKED",
    DUPLICATE_GOOGLE = "DUPLICATE_GOOGLE",
    DUPLICATE_EXACT = "DUPLICATE_EXACT",
    MALFORMED = "MALFORMED",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}